module.exports = __webpack_public_path__ + "img/admin_avatar.64e28f09.jpg";